import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import MusicToggle from './MusicToggle';

function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isMoviePage = location.pathname === '/movie';
  const isArtPage = location.pathname === '/art';

  const isTeamPage = location.pathname === '/team';
  const isStorybookPage = location.pathname === '/storybook';

  const bgImage = isMoviePage
    ? '/bgnew.webp'
    : isArtPage
      ? '/bgart.webp'
      : isTeamPage || isStorybookPage
        ? '/bgextwhite.webp'
        : '/bgextdark.webp';

  return (
    <div className='flex flex-col min-h-screen relative'>
      {!isHomePage && (
        <div
          className={`absolute ${isMoviePage ? 'bottom-0' : 'top-0'} left-0 w-full -z-10 overflow-hidden`}
          style={{ height: '100%' }}
        >
          {/* Mobile background for team page */}
          {isTeamPage && (
            <img
              src={process.env.PUBLIC_URL + '/mobile.webp'}
              alt='Background'
              className='min-[1024px]:hidden w-full h-full object-cover'
            />
          )}
          <img
            src={process.env.PUBLIC_URL + bgImage}
            alt='Background'
            className={`${isTeamPage ? 'hidden min-[1024px]:block' : ''} ${isArtPage || isMoviePage || isStorybookPage ? 'w-full h-full object-cover' : 'w-full h-auto'} ${isMoviePage ? 'absolute bottom-0' : ''}`}
          />
        </div>
      )}
      <Navigation />
      {/* Music toggle */}
      {isArtPage && <MusicToggle />}
      <main className='flex-1 px-[25px] md:px-[50px] pt-20 pb-[100px] relative z-10'>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
